import { createFileRoute, Outlet } from '@tanstack/react-router';

import AdvisorPanel from '@/components/Chat/AdvisorPanel';
import MinimalFooter from '@/components/common/MinimalFooter';
import MinimalHeader from '@/components/common/MinimalHeader';
import { DEFAULT_ADVISOR } from '@/config/defaultAdvisor';
import { useAdvisorOptional } from '@/context/useAdvisorContext';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export const Route = createFileRoute('/_chat')({
  component: ChatLayoutRoute,
});

function ChatLayoutRoute() {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const advisorContext = useAdvisorOptional();

  // Use advisor from context if available, otherwise use default
  const advisorName = advisorContext?.hasAdvisor
    ? advisorContext.advisorDisplayName
    : DEFAULT_ADVISOR.name;
  const advisorPhone = advisorContext?.advisor?.phone || DEFAULT_ADVISOR.phone;

  return (
    <div className="flex h-screen max-w-full flex-col overflow-x-hidden bg-surface-primary">
      <MinimalHeader
        rightContent={<AdvisorPanel name={advisorName} phone={advisorPhone} />}
        showLanguageSwitcher={true}
        mobileVariant="compact"
      />
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
      <MinimalFooter variant={isDesktop ? 'desktop' : 'mobile'} />
    </div>
  );
}
